import { render, staticRenderFns } from "./AssignmentsDetail.vue?vue&type=template&id=648f09e4&scoped=true&"
import script from "./AssignmentsDetail.vue?vue&type=script&lang=js&"
export * from "./AssignmentsDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsDetail.vue?vue&type=style&index=0&id=648f09e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f09e4",
  null
  
)

export default component.exports